import VueMultiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import Vue from 'vue';
Vue.component('multiselect', VueMultiselect);
